import { EmergencyAlertResponse } from '@core/models/emergency-alert-response.model';

export class ResetSaleStatusAction {
  static readonly type = '[Sale] Reset sale status';
}

export class SetHasActiveSaleAction {
  static readonly type = '[Sale] Set has active sale';
  constructor(public hasActiveSale: boolean) {}
}

export class ApiSalesSummaryAction {
  static readonly type = '[Api] Get sales summary';
}

export class SetEmergencyAlertResponse {
  static readonly type = '[Api] Set emergency alerts';
  constructor(public emergencyAlertResponse: EmergencyAlertResponse) {}
}

export class GetEmergencyAlertResponse {
  static readonly type = '[Api] Get emergency alerts';
}
